module.exports = __webpack_public_path__ + "media/images/tables/2side-4380b1e1812845528922892d7df55572.png";